import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { formatName, getFirstName, getLastName, getEmail } from 'utils/talent';

import { Talent, User } from '@libs/graphql-types';

export const useSetSentryUser = (user: Talent | User | undefined) => {
  useEffect(() => {
    const currentScope = Sentry.getCurrentScope();
    const userFromSentry = currentScope?.getUser() || {};

    if (user && !Object.keys(userFromSentry).length) {
      const name = formatName({
        firstName: getFirstName(user),
        lastName: getLastName(user),
      });
      const email = getEmail(user);
      const userId = user?.id;
      Sentry.setUser({ name, email, id: userId });
    }

    return () => {
      Sentry.setUser(null);
    };
  }, [user]);
};
